import './checkout.css'
import { useEffect } from "react";
import $ from 'jquery'
import Footer from "../../components/footer/footer"
import Header from "../../components/header/header"
import SearchModel from "../../components/search_model/search";
import { customScript } from "../../common/customscript";
import bankCard from "../../assets/images/bank-card.png";

const Checkout = () => {
    useEffect(() => {
        customScript()
        $(".card-number").keyup(function () {
            if ($('.card-number').val().length === 16) {
                $('.card-expiry-month').focus();
            }
        });
        $(".card-expiry-month").keyup(function () {
            if ($('.card-expiry-month').val().length === 2) {
                $('.card-expiry-year').focus();
            }
        });
        $(".card-expiry-year").keyup(function () {
            if ($('.card-expiry-year').val().length === 2) {
                $('.card-cvc').focus();
            }
        });
    }, [])

    return (
        <>
            <Header />
            <div className="py-4">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-6 col-md-10 d-flex justify-content-center flex-column">
                            <div className="paymentCard card w-100 shadow-sm">
                                <div className="card-header">
                                    <p>Checkout</p>
                                </div>
                                <div className="my-account-content card-body pt-md-5 pr-md-5 pl-md-5"
                                    style={{ margin: 0 }}>
                                    <div className="w-100">
                                        <div className="text-center">
                                            <h4 className="font-weight-bold mb-0">$100.00 USD</h4>
                                            <p style={{ fontSize: '14px', fontWeight: 600 }}>Customer email: abc@gmail.com</p>
                                        </div>
                                        <div>
                                            <form className="require-validation" id="payment-form" onSubmit={(e)=>e.preventDefault()}>
                                                <div className="inputs-div inputs-div_ mb-2 mt-2">
                                                    <input
                                                        autoComplete='off'
                                                        required
                                                        placeholder='Email address'
                                                        type='email' />
                                                </div>
                                                <div className="inputs-div inputs-div_ mb-2">
                                                    <input
                                                        autoComplete='off'
                                                        required
                                                        placeholder='Address'
                                                        type='text' />
                                                </div>
                                                <div className="inputs-div inputs-div_ mb-2">
                                                    <input
                                                        autoComplete='off'
                                                        required
                                                        placeholder='Phone number'
                                                        type='number' />
                                                </div>
                                                <div>
                                                    <label>Card Number</label>
                                                </div>
                                                <div className="mb-3">
                                                    <div className="inputs-div">
                                                        <img src={bankCard} style={{ width: '20px', marginRight: '7px' }} alt="" />
                                                        <input
                                                            autoComplete='off'
                                                            className='card-number move-input'
                                                            placeholder='Card number'
                                                            maxLength='16'
                                                            minLength="16"
                                                            type='text' />
                                                        <input
                                                            autoComplete='off'
                                                            className='card-expiry-month move-input'
                                                            placeholder='MM'
                                                            maxLength='2'
                                                            minLength="2"
                                                            type="text" />
                                                        <input
                                                            autoComplete='off'
                                                            className='card-expiry-year move-input'
                                                            placeholder='YY'
                                                            maxLength='2'
                                                            minLength="2"
                                                            type='text' />
                                                        <input
                                                            autoComplete='off'
                                                            className='card-cvc move-input'
                                                            placeholder='CVC'
                                                            maxLength='3'
                                                            type='text'
                                                            minLength="3" />
                                                    </div>
                                                </div>
                                                <div className="d-flex justify-content-between">
                                                    <button
                                                        type="submit"
                                                        className="default-btn"
                                                        style={{ margin: 0 }}
                                                    >
                                                        Pay Now</button>
                                                    <button
                                                        type="submit"
                                                        className="default-btn"
                                                        style={{ margin: 0 }}
                                                    >
                                                        Cash on Delivery</button>
                                                </div>
                                                <div className="cards-visa">
                                                    <div>
                                                        <i className="fa-brands fa-cc-visa"></i>
                                                        <i className="fa-brands fa-cc-mastercard"></i>
                                                        <i className="fa-brands fa-cc-amex"></i>
                                                        <i className="fa-brands fa-cc-discover"></i>
                                                    </div>
                                                    <div className="stripe-text">Powered by <span>Stripe</span></div>
                                                </div>
                                            </form>
                                        </div>
                                        <div>
                                            <table className="w-100">
                                                <thead style={{ borderBottom: '1px solid #707070' }}>
                                                    <tr>
                                                        <th style={{ paddingBottom: '8px' }}>Description</th>
                                                        <th style={{ paddingBottom: '8px' }}>Qty</th>
                                                        <th style={{ paddingBottom: '8px' }}>Amount</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr style={{ borderBottom: '1px solid #707070' }}>
                                                        <td className="d-flex"
                                                            style={{ padding: '10px 0' }}
                                                        >
                                                            <div style={{ width: '70px', height: '47px', marginRight: '10px' }}>
                                                                <img src="https://fiverr-res.cloudinary.com/t_gig_cards_web,q_auto,f_auto/gigs/138196807/original/9e69033f25a157d1c1eb339440d9eebd956b4396.jpg"
                                                                    style={{ width: '100%', height: '100%' }} alt="" />
                                                            </div>
                                                            <div>
                                                                <h6 style={{ fontSize: '14px', marginBottom: '2px', fontWeight: 600 }}> title</h6>
                                                            </div>
                                                        </td>
                                                        <td style={{ width: '45px', padding: '10px 0 10px 10px' }}>1</td>
                                                        <td style={{ width: '71px', padding: '10px 0 10px 5px' }}>$100.00</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card-footer">
                                <button className='default-btn'><i className='fa-solid fa-location'></i> Track Service Provider</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
            <SearchModel />
        </>
    )
}

export default Checkout